const moment = require('moment');

const DOCUMENTVERIFICATIONDIGIT = 'TRWAGMYFPDXBNJZSQVHLCKE';
const NIFModule23 = 23;
const REGEXNAME = /^(?:(?=[^\^_\]\[])[A-záéíóúÁÉÍÓÚñÑ\s])+$/;
const REGEXNIE = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/;
const REGEXDNI = /^[0-9]{8}[A-Z]{1}$/;

const decimalVerificationLetter = value => {
    const decimalVerification = parseInt(value.substring(0, value.length - 1)) % NIFModule23;
    return DOCUMENTVERIFICATIONDIGIT.charAt(decimalVerification) === value.substring(value.length - 1, value.length);
}

const isValidNif = value => {

    const hasErrors = !REGEXDNI.test(value) || !decimalVerificationLetter(value);
    return !hasErrors;
}

const isValidNie = value => {
    const replaceFirstLetter = value.replace(/^[X]/g, '0').replace(/^[Y]/g, '1').replace(/^[Z]/g, '2');
    const foundErrors = !REGEXNIE.test(value) || !decimalVerificationLetter(replaceFirstLetter);
    return !foundErrors;
}

const isValidName = value => {
    return REGEXNAME.test(value)
}

const validateDate = (day, month, year) => {
    const dia = parseInt(day);
    const mes = parseInt(month);
    const anio = parseInt(year);
    const errorsFound = {
        dayError: false,
        monthError: false,
        yearError: false
    };

    if (dia == 31 && (mes == 4 || mes == 6 || mes == 9 || mes == 11)) {
        errorsFound.dayError = true;
    } else if (dia >= 30 && mes == 2) {
        errorsFound.dayError = true;
    } else if (dia > 31 && dia <= 29) {
        errorsFound.dayError = true;
    } else if (
        mes == 2 &&
        dia == 29 &&
        !(anio % 4 == 0 && (anio % 100 != 0 || anio % 400 == 0))
    ) {
        errorsFound.yearError = true;
    }

    if (dia <= 0 || dia > 31) {
        errorsFound.dayError = true;
    }

    if (anio <= 0) {
        errorsFound.yearError = true;
    }

    if (mes <= 0 || mes > 12) {
        errorsFound.monthError = true;
    }

    return errorsFound;
}

const validateExpirationDate = (day, month, year) => {
    const now = moment().format('YYYY-MM-DD');
    const expirationDate = moment([year, month - 1, day]).format('YYYY-MM-DD');
    return !(expirationDate <= now);
}


module.exports = {
    isValidNif,
    isValidNie,
    validateDate,
    validateExpirationDate,
    isValidName,
    REGEXNAME,
    REGEXNIE,
    REGEXDNI
}

